// Check if we're in development environment
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

// Check localStorage for isDevMode (defaults to false/hidden)
export const getIsDevelopment = () => {
  if (!IS_DEVELOPMENT) return false;

  try {
    const storedValue = localStorage.getItem('isDevMode');
    return storedValue === 'true';
  } catch (e) {
    return false;
  }
};
